import { MODULE_ICON, MODULE_TITLE } from "../modules.ts";
import {
  ANALYTICS_PRODUCT_PATH,
  CAMPAIGNS_PRODUCT_PATH,
  DEMO_PATH,
  GUIDE_PATH,
  INTELLIGENCE_PRODUCT_PATH,
  REWARDS_PRODUCT_PATH,
  PRICING_PATH,
  PRIVACY_PATH,
  WORKSPACE_PRODUCT_PATH,
  SUPPORT_HREF,
  TERMS_PATH,
} from "../routes.ts";
import type { IconName } from "../ui/icons.ts";
import { m } from "../paraglide/messages.js";

export interface NavLink {
  readonly key: string;
  readonly href: string;
  readonly icon: IconName;
  readonly label: () => string;
  readonly hint: () => string;
  readonly away?: true;
}

export const PRODUCTS: readonly NavLink[] = [
  {
    key: "analytics",
    href: ANALYTICS_PRODUCT_PATH,
    icon: MODULE_ICON.analytics,
    label: MODULE_TITLE.analytics,
    hint: m.products_menu_analytics_desc,
  },
  {
    key: "intelligence",
    href: INTELLIGENCE_PRODUCT_PATH,
    icon: MODULE_ICON.intelligence,
    label: MODULE_TITLE.intelligence,
    hint: m.products_menu_intelligence_desc,
  },
  {
    key: "rewards",
    href: REWARDS_PRODUCT_PATH,
    icon: MODULE_ICON.rewards,
    label: MODULE_TITLE.rewards,
    hint: m.products_menu_leveling_desc,
  },
  {
    key: "campaigns",
    href: CAMPAIGNS_PRODUCT_PATH,
    icon: MODULE_ICON.campaigns,
    label: MODULE_TITLE.campaigns,
    hint: m.products_menu_campaigns_desc,
  },
];

export const WORKSPACE: NavLink = {
  key: "workspace",
  href: WORKSPACE_PRODUCT_PATH,
  icon: MODULE_ICON.workspace,
  label: MODULE_TITLE.workspace,
  hint: m.products_menu_workspace_desc,
};

export const FEATURED: readonly NavLink[] = [
  {
    key: "pulse",
    href: `${INTELLIGENCE_PRODUCT_PATH}#insights`,
    icon: "pulse",
    label: m.features_pulse,
    hint: m.products_menu_pulse_hint,
  },
  {
    key: "import",
    href: `${REWARDS_PRODUCT_PATH}#import`,
    icon: "import",
    label: m.leveling_page_import,
    hint: m.pricing_compare_leveling_import,
  },
];

export const PRICING: Pick<NavLink, "key" | "href" | "icon"> = {
  key: "pricing",
  href: PRICING_PATH,
  icon: "billing",
};

export const DEMO: NavLink = {
  key: "demo",
  href: DEMO_PATH,
  icon: "demo",
  label: m.marketing_menu_demo,
  hint: m.marketing_menu_demo_hint,
};

export const RESOURCES: readonly NavLink[] = [
  {
    key: "guide",
    href: GUIDE_PATH,
    icon: "guide",
    label: m.marketing_menu_guide,
    hint: m.marketing_menu_guide_hint,
  },
  {
    key: "support",
    href: SUPPORT_HREF,
    icon: "support",
    label: m.marketing_menu_support,
    hint: m.marketing_menu_support_hint,
    away: true,
  },
];

export const LEGAL: readonly Pick<NavLink, "key" | "href" | "icon" | "label">[] = [
  { key: "terms", href: TERMS_PATH, icon: "terms", label: m.legal_terms_title },
  { key: "privacy", href: PRIVACY_PATH, icon: "privacy", label: m.legal_privacy_title },
];
